$(function () {
    $(".currentPage").parents('.sidebar-entry--main').addClass('header-menu-current-page');
    $(".currentPage").parent('.menu-open').parent('.treeview').addClass('parent-menu-current-page');
    
})